import React from "react";
import Grid from "@material-ui/core/Grid";
import {DataTable} from "primereact/datatable";
import {Column} from "primereact/column";
import HeaderPage from "../../app/Title/SubtitleLabel/SubtitleLabelView";
import SubtitleLabel from "../../app/Title/SubtitleLabel/SubtitleLabelView";

const LoanData = (props) => {
    return (
        <React.Fragment>
            <Grid container spacing={2}>
                <Grid item xs={12}>
                    <HeaderPage header="Préstamo" isBold={true}/>
                </Grid>
                <Grid item xs={3}>
                    <DataTable
                        className="noHeader"
                        value={props.detailLoan_1}
                        resizableColumns={true}
                        columnResizeMode={"fit"}
                    >
                        <Column field="name" style={{fontWeight: 'bold'}}/>
                        <Column field="value"/>
                    </DataTable>
                </Grid>
                <Grid item xs={3}>
                    <DataTable
                        className="noHeader"
                        value={props.detailLoan_2}
                        resizableColumns={true}
                        columnResizeMode={"fit"}
                    >
                        <Column field="name" style={{fontWeight: 'bold'}}/>
                        <Column field="value"/>
                    </DataTable>
                </Grid>
                <Grid item xs={3}>
                    <DataTable
                        className="noHeader"
                        value={props.detailLoan_3}
                        resizableColumns={true}
                        columnResizeMode={"fit"}
                    >
                        <Column field="name" style={{fontWeight: 'bold'}}/>
                        <Column field="value"/>
                    </DataTable>
                </Grid>
                <Grid item xs={3}>
                    <DataTable
                        className="noHeader"
                        value={props.detailLoan_4}
                        resizableColumns={true}
                        columnResizeMode={"fit"}
                    >
                        <Column field="name" style={{fontWeight: 'bold'}}/>
                        <Column field="value"/>
                    </DataTable>
                </Grid>
            </Grid>
            <SubtitleLabel header="Valores Aceptados en Garantía: " isBold={true}/> &nbsp;
            <SubtitleLabel header={props.restrictions}/>
        </React.Fragment>
    )
};

export default LoanData;